import React, { Component } from 'react';
import axios from 'axios';
import '../../assets/css/Register.css';
import { connect } from 'react-redux';
import {changeCurrentUser} from '../../state/actionCreators/index'
import withRouter from '../../utility/withRouter';
import apiInstance from '../apiInstance';
import { GoogleLogin } from '@react-oauth/google';

class Register extends Component {
    constructor() {
        super();
        this.state = {
            email: '',
            password: '',
            name: '',
            view: 'select',
            loading: false,
            error: '',
            fieldErrors: {},
            learnMorePp: React.createRef(),
        };
    }

    handleSignUp = (e) => {
        e.preventDefault();

        this.setState({ fieldErrors: {}, error: "", loading: true })

        var request_body = { email: this.state.email, password: this.state.password, name: this.state.name };
        axios.post(process.env.REACT_APP_SERVER_URL + `/user`, request_body)
            .then(async (response) => {
                localStorage.setItem('token', response.data.user.token);
                localStorage.setItem('userId', response.data.user.id)
                this.props.changeCurrentUser(response.data.user)

                const sid = new URLSearchParams(this.props.location.search).get('sid');
                if (sid) {
                    try {
                        await apiInstance.put('/dashboard/claim', {
                            userId: response.data.user.id,
                            siteId: sid
                        });
                    } catch (err) {
                        console.error('Claim failed:', err.message);
                    }
                    window.location.href = '/websites';
                } else {
                    const redirect = new URLSearchParams(this.props.location.search).get('redirect');
                    window.location.href = redirect ? decodeURIComponent(redirect) : "/websites";
                }
            })
            .catch((error) => {
                console.log(error)
                if (error.response) {
                    if (error.response.status == 400 && error.response.data.fieldErrors) {
                        this.setState({ fieldErrors: error.response.data.fieldErrors, loading: false })
                    } else {
                        this.setState({ error: error.response.data?.message || 'Something went wrong, please try again later', loading: false })
                    }
                } else {
                    this.setState({ loading: false })
                }
            });
    }

    handleInputChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState((prevState) => {
            return ({
                ...prevState,
                [name]: value
            })
        })
    }

    handleLearnMore = (e) => {
        this.state.learnMorePp.current.openPopup()
    }

    handleGoogleSuccess = (googleResponse) => {

        this.setState({ loading: true, error: '' });

        axios.post(process.env.REACT_APP_SERVER_URL + `/user/google-auth`, {
            idToken: googleResponse.credential
        })
            .then(async (response) => {
                localStorage.setItem('token', response.data.user.token);
                localStorage.setItem('userId', response.data.user.id);
                this.props.changeCurrentUser(response.data.user)

                const sid = new URLSearchParams(this.props.location.search).get('sid');
                if (sid) {
                    try {
                        await apiInstance.put('/dashboard/claim', {
                            userId: response.data.user.id,
                            siteId: sid
                        });
                    } catch (err) {
                        console.error('Claim failed:', err.message);
                    }
                    window.location.href = '/websites';
                } else {
                    const redirect = new URLSearchParams(this.props.location.search).get('redirect');
                    window.location.href = redirect ? decodeURIComponent(redirect) : "/websites";
                }
            })
            .catch((error) => {
                console.log(error)
                this.setState({ error: error.response?.data?.message || 'Google sign-in failed. Please try again.', loading: false })
            });
    }

    handleGoogleError = () => {
        this.setState({ error: 'Google sign-in failed. Please try again.', loading: false });
    }

    render() {
        let { view, name, email, password, loading, error, fieldErrors } = this.state;
        return (
            <div className="mjs-register-wrapper">
                <div className={`mjs-rg-container right-panel-active`} id="mjs-rg-container">
                    <div className={`mjs-rg-form-container mjs-rg-sign-up-container`}>

                        <form action="#">
                            <h1>Create Account</h1>

                            {view === 'select' &&
                                <>
                                    <GoogleLogin onSuccess={this.handleGoogleSuccess} onError={this.handleGoogleError} text="signup_with"/>
                                    <div className="mjs-or-divider"><span>OR</span></div>
                                    <button type="button" disabled={loading} onClick={() => this.setState({view: 'email', error: '', fieldErrors: {}})}>Continue with Email</button>
                                </>
                            }

                            {view === 'email' &&
                                <>
                                    <div className='mjs-back-btn'>
                                        <button type="button" disabled={loading} onClick={() => this.setState({view: 'select', error: '', fieldErrors: {}})}><i className="fa-solid fa-arrow-left"></i></button>
                                    </div>

                                    <div className='mjs-register-usrname'><i className="fa-solid fa-user"></i><input
                                        type="text"
                                        placeholder="Your Name"
                                        name="name"
                                        value={name}
                                        onChange={this.handleInputChange}
                                    /></div>
                                    {fieldErrors.name && <span className="mjs-error">{fieldErrors.name}</span>}

                                    <div className='mjs-register-emailadrs'><i className="fa-solid fa-envelope"></i><input
                                        type="email"
                                        placeholder="Email Address"
                                        name="email"
                                        value={email}
                                        onChange={this.handleInputChange}
                                    /></div>
                                    {fieldErrors.email && <span className="mjs-error">{fieldErrors.email}</span>}

                                    <div className='mjs-register-passwrd'><i className="fa-solid fa-lock"></i><input
                                        type="password"
                                        placeholder="Password"
                                        name="password"
                                        value={password}
                                        onChange={this.handleInputChange}
                                    /></div>
                                    {fieldErrors.password && <span className="mjs-error">{fieldErrors.password}</span>}

                                    <button
                                        onClick={this.handleSignUp}
                                        disabled={!name || !email || !password || loading}
                                    >
                                        {loading ? <i className="fa-solid fa-spinner fa-spin"></i> : 'Sign Up'}
                                    </button>
                                </>
                            }

                            {loading && view === 'select' && <i className="fa-solid fa-spinner fa-spin"></i>}
                            <span className="mjs-error">{error}</span>
                            <div className="mjs-auth-link">
                                Already have an account? <a href={`/login${new URLSearchParams(this.props.location.search).get('sid') ? '?sid=' + new URLSearchParams(this.props.location.search).get('sid') : ''}`}>Login</a>
                            </div>

                        </form>

                    </div>
                    <div className="mjs-rg-overlay-container">
                        <div className="mjs-rg-overlay">
                            <div className={`mjs-rg-overlay-panel mjs-rg-overlay-left`}>
                                <h2>Welcome to StateFolio</h2>
                                <p>Your business website is fully built and waiting. Register now to access your private dashboard and start managing your brand online.</p>
                                <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Claim Your Website</p>
                                <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Unlock your Dashboard</p>
                                <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Start Free</p>
                                <p><i class="mjs_text_light_blue fa-solid fa-check"></i> No Credit Card Required</p>

                                <div className="mjs-mt-5"><div className='mjs-btn' onClick={this.handleLearnMore}>Learn More</div></div>

                            </div>
                        </div>
                    </div>
                </div>

                <LearnMorePopup ref={this.state.learnMorePp}/>

            </div>
        );
    }
}

class LearnMorePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayPopup: false
        };
    }

    openPopup = () => {
        this.setState({ displayPopup: true })
    }

    closePopup = () => {
        this.setState({ displayPopup: false })
    }

    render () {
        let {displayPopup} = this.state;
        const pricing_amount = process.env.REACT_APP_STRIPE_MONTHLY_PRICING;
        return (
            <div className={'mjs-popup' + (displayPopup ? '' : ' mjs-hidden')}>
                <div className="mjs-forgotpwd">
                    <h2>Claim Your Website & Start Getting More Leads Today</h2>
                    <span className="mjs-popup-close" onClick={this.closePopup}>
                        <i className="fa-solid fa-xmark"></i>
                    </span>
                    <div className='mjs-row mjs-text-left'>
                        <div className='mjs-col50'>

                            <h4>Why We Built This For You</h4>

                            <p>Instead of forcing business owners to:</p>
                            <p><i class="mjs_text_error fa-solid fa-xmark"></i> Hire designers</p>
                            <p><i class="mjs_text_error fa-solid fa-xmark"></i> Wait weeks for development</p>
                            <p><i class="mjs_text_error fa-solid fa-xmark"></i> Pay thousands upfront</p>
                            <p><i class="mjs_text_error fa-solid fa-xmark"></i> Worry about hosting & security</p>
                            <p><i class="mjs_text_error fa-solid fa-xmark"></i> Deal with technical headaches</p>

                            <h5>We flipped the model:</h5>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> We pre-built your website</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> We handle hosting, updates, and security</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Go live in minutes, not weeks</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> You only pay after you see it</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Zero risk. Zero setup. Immediate results.</p>

                        </div>

                        <div className='mjs-col50'>
                            <h4>Simple, Transparent Pricing</h4>

                            <p>Simple pricing. Zero guesswork.</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Start Free</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> ${pricing_amount} / Month after full activation</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> No setup or upfront fees</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> No long-term contracts</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> You can cancel anytime.</p>

                            <h5>Includes:</h5>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Website hosting with Professional Emails</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Lifetime updates & security</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Technical support</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Performance monitoring and SEO Optimization</p>
                            <p><i class="mjs_text_light_blue fa-solid fa-check"></i> Backup & uptime protection</p>

                        </div>
                        
                    </div>

                    <p>Your competitors are already online. This ensures <strong>you don't fall behind</strong>.</p>
                    
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return (
        {
            user: state.currentUser,
        }
    )
}
const mapDispatchToProps = (dispatch) => {
    return (
      {
        changeCurrentUser: (user) => { dispatch(changeCurrentUser(user)) },
      }
    )
  }
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register));